import { getFormattedDate, normalizeUTCString } from "../../../utils";
export var getDateParts = function getDateParts(date) {
  if (!date) return {
    day: "--",
    month: "--",
    time: "--",
    year: "--"
  };
  var day = getFormattedDate(normalizeUTCString(date), "dd", "--");
  var month = getFormattedDate(normalizeUTCString(date), "MMM", "--");
  var time = getFormattedDate(normalizeUTCString(date), "h:mma", "--").toLowerCase();
  var year = getFormattedDate(normalizeUTCString(date), "yyyy", "--");
  return {
    day: day,
    month: month,
    time: time,
    year: year
  };
};